import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RecetasPageRoutingModule } from './recetas-routing.module';

import { RecetasPage } from './recetas.page';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { ProductsComponentModule } from 'src/app/products-component/products-component.module';
import { RecetasComponentsModule } from './recetas-components/recetas-components.module';
import { BreadcrumbsComponent } from 'src/app/components/breadcrumbs/breadcrumbs.component';
import { GalleryComponentsModule } from 'src/app/gallery-components/gallery-components.module';
import { SliderModule } from 'src/app/components/slider/slider.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RecetasPageRoutingModule,
    PipeModule,
    GeneralesComponentsModule,
    ProductsComponentModule,
    RecetasComponentsModule,
    GalleryComponentsModule,
    SliderModule,
  ],
  declarations: [RecetasPage, BreadcrumbsComponent],
})
export class RecetasPageModule {}
